import { CustomClaimValue, Device, HardwareStatuses, Icons, useAuth } from "@app/shared";
import { useState } from "react";
import { useFetch } from "../../hooks";
import { Select } from "./inputs";
import { PageContainer } from "./PageContainer";
import { HardwareChartsPanel } from "./HardwareChartsPanel";

type DeviceStatusChartsProps = {
    device?: Device;
};

const getPeriodByHours = (hours: number) => {
    if (hours <= 12) return 5;
    else if (hours <= 24) return 15;
    else if (hours <= 72) return 30;
    else if (hours <= 168) return 60;
    else if (hours <= 744) return 300;
    return 600;
};

export const DeviceStatusCharts: React.FC<DeviceStatusChartsProps> = ({ device }) => {
    const [hoursToDisplay, setHoursToDisplay] = useState(1);

    const user = useAuth();
    const isSuperAdmin = user.userClaims?.some((uc) => uc.claims.includes(CustomClaimValue.SuperAdmin));

    const [statusHistory, historyError, historyHelpers] = useFetch(
        () => (device ? HardwareStatuses.getHistoryForDevice(device.id, hoursToDisplay, getPeriodByHours(hoursToDisplay)) : Promise.resolve(undefined)),
        [device, hoursToDisplay]
    );

    return (
        <PageContainer
            Icon={Icons.StatsDots}
            title="Hardware Status"
            titleRight={
                <Select
                    options={[
                        { value: "1", label: "1 Hour" },
                        { value: "4", label: "4 Hours" },
                        { value: "8", label: "8 Hours" },
                        { value: "12", label: "12 Hours" },
                        { value: "24", label: "1 Day" },
                        { value: "72", label: "3 Days" },
                        { value: "168", label: "1 Week" },
                        { value: "730", label: "1 Month" },
                    ]}
                    value={hoursToDisplay.toString()}
                    onChange={(e) => setHoursToDisplay(parseInt(e.target.value))}
                />
            }
        >
            <HardwareChartsPanel
                data={statusHistory}
                mode="miniRow"
                isLoading={historyHelpers.isLoading}
                error={historyError ? (isSuperAdmin ? historyError : "An error occurred") : undefined}
            />
        </PageContainer>
    );
};
